import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import { i18n } from './plugins/firecrudlib.js'

Vue.config.productionTip = false

store.commit('setLang', 'de') // console 'de' only
i18n.setLocale('de')

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
